export default "__VITE_ASSET__8510bf8c__"